/**
 * Helper functions for managing the "fuid" (Foodango User ID) cookie
 * Used for server-side GTM (sGTM) user tracking
 */

import Cookies from "js-cookie";

const FUID_COOKIE_NAME = "fuid";
const COOKIE_MAX_AGE = 365; // 1 year in days

/**
 * Sets the fuid cookie with the given user ID
 */
export const setFuidCookie = (userId: string): void => {
  Cookies.set(FUID_COOKIE_NAME, userId, {
    expires: COOKIE_MAX_AGE,
    path: "/",
    sameSite: "lax",
    secure: true,
  });
};

/**
 * Gets the current fuid cookie value
 */
export const getFuidCookie = (): string | null => {
  return Cookies.get(FUID_COOKIE_NAME) || null;
};

/**
 * Sets the fuid cookie to null (indicates user logged out)
 * This allows tracking of logout events
 */
export const setFuidCookieNull = (): void => {
  Cookies.set(FUID_COOKIE_NAME, "null", {
    expires: COOKIE_MAX_AGE,
    path: "/",
    sameSite: "lax",
    secure: true,
  });
};

/**
 * Removes the fuid cookie by setting it to expire immediately
 */
export const removeFuidCookie = (): void => {
  Cookies.remove(FUID_COOKIE_NAME, { path: "/" });
};
